module.exports = [{"allowBackground":true,"pageColor":"0xffffff","placeholders":[{"left":0,"top":0,"width":0,"height":0}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/flyleafes/back/square.json
// module id = 872
// module chunks = 0